export const getTimeFormat = (date) => {
    // const firstdate = date.split("T")[0]
    // const formatedDate = date
    //     ?.split("T")[1]
    //     ?.split(":")
    //     ?.slice(0, 2)
    //     ?.join(":")
    // return `${firstdate} ${formatedDate}`;

    const local = new Date(date).toLocaleDateString();
    const hr = new Date(date).toLocaleTimeString().split(":")[0];
    const min = new Date(date).toLocaleTimeString().split(":")[1];
    return `${local} ${hr}:${min}`;

};

export const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${minutes} ${ampm}`;
};